import React, { useEffect, useRef, useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import ButtonActionIcon from "../BuilderComponents/ButtonActionIcon";
import CodeEditor from "../BuilderComponents/CodeEditor/CodeEditor";
import CustomJS from "../BuilderComponents/CustomJS";
import JobConfigration from "../BuilderComponents/JobConfigration/JobConfigration";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import { toastError } from "../../utils/toastUtils";
import Button from "../FormComponents/Button";
import Input from "../FormComponents/Input";

const EditHtmlContent = ({ editElementData, setEditElementData, tableID = "", places, element = "", device }) => {
  const [htmlContent, setHtmlContent] = useState(editElementData.content || "");
  const [selectedTab, setSelectedTab] = useState("html");
  const [targetActions, setTargetActions] = useState({});
  const [allJobs, setAllJobs] = useState([]);

  const fetchAllJobs = async () => {
    try {
      const { data } = await axiosInstance.get(`/jobs/filter/?places=${places}&elements=${element}`);
      setAllJobs(data);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleSaveHtmlContent = () => {
    setEditElementData({ ...editElementData, content: htmlContent, target_actions: targetActions });
  };

  const hanndleChangeHtmlContent = (code) => {
    // const newContent = e.target.value;
    setHtmlContent(code);
  };

  const handleChangeTargetAction = (data) => {
    setTargetActions(data);
  };

  useEffect(() => {
    fetchAllJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // const formattedHtml = html_beautify(editElementData.content, {
    //   indent_size: 2
    // });
    setHtmlContent(editElementData.content);
    setTargetActions(editElementData.target_actions || {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editElementData.id]);

  return (
    <>
      <div className="sidebar_tab_buttons mediumtab" style={{ width: "554px" }}>
        {["html", "actions"].map((tabName) => (
          <div
            className={`sidebar_tabs ${selectedTab === tabName ? "active" : ""}`}
            key={tabName}
            onClick={() => setSelectedTab(tabName)}
          >
            {tabName}
          </div>
        ))}
      </div>
      <div>
        {selectedTab === "html" && (
          <>
            <div className="p_3">
              {editElementData.type === "dynamic-html" ? (
                <CustomJS
                  inputString={htmlContent}
                  tableID={tableID}
                  handleChange={(data) => setHtmlContent(data)}
                  label="Write HTML"
                  onlyFieldId={false}
                />
              ) : (
                <CodeEditor
                  language="html"
                  value={htmlContent}
                  handleChange={hanndleChangeHtmlContent}
                  enableBacktickTrigger={false}
                />
              )}
            </div>
          </>
        )}
        {selectedTab === "actions" && (
          <HTMLTargetActions
            targetActions={targetActions}
            changeAction={handleChangeTargetAction}
            tableID={tableID}
            device={device}
            allJobs={allJobs}
          />
        )}
      </div>
      <div
        className="save_block down html_save_down"
        style={{
          borderTop:
            selectedTab === "actions" && Object.keys(targetActions).length > 0
              ? "solid 1px var(--builder-border)"
              : "none",
          padding: "20px"
        }}
      >
        <Button onClick={handleSaveHtmlContent}>Save</Button>
      </div>
    </>
  );
};

const HTMLTargetActions = ({ targetActions, changeAction, tableID, device, allJobs }) => {
  const [targetId, setTargetId] = useState("");
  const [isValidTargetId, setIsValidTargetId] = useState(true);
  const [selectedTarget, setSelectedTarget] = useState("");

  const handleChangeTargetId = (e) => {
    const value = e.target.value;
    setTargetId(value);
  };

  const checkForValidTargetId = (targetId) => {
    const regex = /^[A-Za-z_]{5,}$/;
    return regex.test(targetId);
  };

  const addTargetAction = () => {
    const newString = targetId.trim();
    if (!checkForValidTargetId(newString)) {
      setIsValidTargetId(false);
      return;
    }
    if (targetActions[newString]) {
      toastError("ID already assigned");
      return;
    }
    setIsValidTargetId(true);
    setTargetId("");
    changeAction({
      ...targetActions,
      [newString]: {}
    });
    setSelectedTarget(newString);
  };

  const deleteTargetAction = (e, actionName) => {
    e.stopPropagation();
    const newTargetActions = { ...targetActions };
    delete newTargetActions[actionName];
    changeAction(newTargetActions);
    if (selectedTarget === actionName) {
      setSelectedTarget("");
    }
  };

  const handleTargetActionChange = (jobData) => {
    const newTargetActions = { ...targetActions };
    newTargetActions[selectedTarget] = jobData;
    changeAction(newTargetActions);
  };

  return (
    <>
      <div className="p_3">
        <div className="builder_form mb_2">
          <Input
            type="text"
            label="Enter Target ID"
            placeholder="Enter target ID"
            value={targetId}
            onChange={handleChangeTargetId}
          />
        </div>
        {!isValidTargetId && (
          <div className="">
            <p style={{ color: "red" }}>Target ID must be at least 5 characters long </p>
            <p style={{ color: "red" }}>only contain underscores and alphabetic characters.</p>
          </div>
        )}
        <div className="mb_2">
          <Button variant="secondary" size="small" onClick={addTargetAction} style={{ marginLeft: "auto" }}>
            <MaterialIcon name="add" style={{ fontSize: "20px" }} />
          </Button>
        </div>
        {Object.keys(targetActions).length > 0 && (
          <div className="detailsView_variable_outer">
            <div className="variable_block_left">
              {Object.keys(targetActions).map((action) => (
                <div
                  onClick={() => setSelectedTarget(action)}
                  key={action}
                  className={`button_column_list ${action === selectedTarget ? "selected" : ""} p_4`}
                >
                  <span style={{ userSelect: "text" }}>{action}</span>
                  <ButtonActionIcon type="delete" onClick={(e) => deleteTargetAction(e, action)} />
                </div>
              ))}
            </div>
            <div>
              {selectedTarget && (
                <JobSelectionAndPreview
                  currentJob={targetActions[selectedTarget]}
                  changeCurrentJob={handleTargetActionChange}
                  tableId={tableID}
                  allJobs={allJobs}
                  device={device}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const JobSelectionAndPreview = ({ currentJob, changeCurrentJob, tableId, allJobs, device }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const templateObject = useRef({});

  const deleteJob = () => {
    changeCurrentJob({});
  };

  const addTriggerdJob = (data) => {
    changeCurrentJob({ ...data });
    setIsModalOpen(false);
  };

  return (
    <>
      {!currentJob?.job_id && (
        <div className="p_3">
          <Button onClick={() => setIsModalOpen(true)}>Add job</Button>
        </div>
      )}
      {currentJob?.job_id && !isModalOpen && (
        <div className="job_single_card rightpanel m_4">
          <div className="overlay_cover"></div>
          <div className="job_action_btn">
            <ButtonActionIcon size="sm" type="edit" onClick={() => setIsModalOpen(true)} />
            <ButtonActionIcon size="sm" type="delete" onClick={() => deleteJob()} />
          </div>
          <JobConfigration
            templateObject={templateObject.current}
            editJob={{ job_id: currentJob.job_id, params: currentJob.params }}
            allJobs={allJobs}
            isReadOnly={true}
            smId={tableId}
            device={device}
          />
        </div>
      )}
      <BuilderModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} modalName="Add job">
        <JobConfigration
          templateObject={templateObject.current}
          editJob={currentJob?.job_id ? { job_id: currentJob.job_id, params: currentJob.params } : null}
          allJobs={allJobs}
          onClick={addTriggerdJob}
          smId={tableId}
          device={device}
        />
      </BuilderModal>
    </>
  );
};

export default EditHtmlContent;
